import React from 'react';
import { WizardWrapper } from './logic/WizardWrapper';
import { ChangePersonalAddressSteps } from './ChangePersonalAddressSteps';
import { errorCodesEnum } from './logic/useStepHook';

export interface ChangeInvalidBusinessAddressProps {
  onAddressUpdatedSuccessfully: () => void;
}

export interface ErrorData {
  errorMessage?: string;
  errorCode?: number;
  errorKey: errorCodesEnum;
  prevStep?: number;
  inlineError?: boolean;
}

export interface ChangePersonalAddressData {
  type: string;
  step?: number;
  error?: ErrorData;
}

export const ChangeInvalidBusinessAddress = ({ onAddressUpdatedSuccessfully }: ChangeInvalidBusinessAddressProps) => (
  <div>
    <WizardWrapper>
      <ChangePersonalAddressSteps onAddressUpdatedSuccessfully={onAddressUpdatedSuccessfully} />
    </WizardWrapper>
  </div>
);
